import {
  arrayOf, bool, number, shape, string,
} from 'prop-types'

const planShape = shape({ tier: string, planType: string, price: number })

// Upgrade quote fields of contract 124g39pcvuz; the page receives them as top-level props.
export const quoteFields = {
  target: string,
  currency: string,
  current: planShape,
  targetPlan: planShape,
  units: shape({ used: number, total: number }),
  credit: shape({ amount: number, planType: string }),
  vatAmount: number,
  amountDue: number,
  newTermStartsAt: string,
  nextRenewalAt: string,
  catalogValue: string,
  allowedTargets: arrayOf(shape({
    target: string.isRequired,
    tier: string.isRequired,
    planType: string.isRequired,
    price: number,
    perModelPrice: number,
    freeMonths: number,
    downloadsPerMonth: number,
    generationsPerMonth: number,
    available: bool,
    blockedReason: string,
  })),
}

export const quoteShape = shape(quoteFields)
